import "./Loader.css";

export const Loader = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="loader bg-primary w-2 h-2 rounded-[50%] aspect-[1]" />
    </div>
  );
};
